import type { AcquirerColumnFilterKey, AcquirerColumnFilters } from '../models/types';

export const COUNTRY_GEO: Record<string, { lat: number; lng: number; region: string }> = {
  "Afghanistan": { lat: 34.13, lng: 66.59, region: "Asia" },
  "Albania": { lat: 41.14, lng: 20.06, region: "Europe" },
  "Algeria": { lat: 28.35, lng: 2.66, region: "Africa" },
  "American Samoa": { lat: -14.31, lng: -170.7, region: "Oceania" },
  "Andorra": { lat: 42.55, lng: 1.58, region: "Europe" },
  "Angola": { lat: -12.17, lng: 17.65, region: "Africa" },
  "Anguilla": { lat: 18.22, lng: -63.06, region: "South America" },
  "Antigua and Barbuda": { lat: 17.07, lng: -61.79, region: "South America" },
  "Argentina": { lat: -35.7, lng: -64.53, region: "South America" },
  "Armenia": { lat: 40.18, lng: 45.05, region: "Middle East" },
  "Aruba": { lat: 12.52, lng: -69.98, region: "South America" },
  "Australia": { lat: -25.7, lng: 134.02, region: "Oceania" },
  "Austria": { lat: 47.63, lng: 13.8, region: "Europe" },
  "Azerbaijan": { lat: 40.39, lng: 48.63, region: "Middle East" },
  "Bahamas": { lat: 24.72, lng: -78.07, region: "South America" },
  "Bahrain": { lat: 26.05, lng: 50.54, region: "Middle East" },
  "Bangladesh": { lat: 23.67, lng: 90.43, region: "Asia" },
  "Barbados": { lat: 13.18, lng: -59.56, region: "South America" },
  "Belarus": { lat: 53.47, lng: 27.96, region: "Europe" },
  "Belgium": { lat: 50.62, lng: 4.68, region: "Europe" },
  "Belize": { lat: 17.24, lng: -88.68, region: "South America" },
  "Benin": { lat: 9.5, lng: 2.31, region: "Africa" },
  "Bermuda": { lat: 32.32, lng: -64.75, region: "North America" },
  "Bhutan": { lat: 27.42, lng: 90.47, region: "Asia" },
  "Bolivia": { lat: -16.73, lng: -64.45, region: "South America" },
  "Bonaire": { lat: 12.18, lng: -68.29, region: "South America" },
  "Bosnia and Herzegovina": { lat: 44.14, lng: 17.83, region: "Europe" },
  "Botswana": { lat: -22.24, lng: 23.86, region: "Africa" },
  "Bouvet Island": { lat: -54.42, lng: 3.41, region: "South America" },
  "Brazil": { lat: -11.52, lng: -54.36, region: "South America" },
  "British Indian Ocean Territory": { lat: -7.32, lng: 72.44, region: "Africa" },
  "British Virgin Islands": { lat: 18.42, lng: -64.62, region: "South America" },
  "Brunei Darussalam": { lat: 4.54, lng: 114.64, region: "Asia" },
  "Bulgaria": { lat: 42.82, lng: 25.25, region: "Europe" },
  "Burkina Faso": { lat: 12.11, lng: -1.69, region: "Africa" },
  "Burundi": { lat: -3.26, lng: 29.89, region: "Africa" },
  "Cabo Verde": { lat: 15.08, lng: -23.63, region: "Africa" },
  "Cambodia": { lat: 12.7, lng: 105.04, region: "Asia" },
  "Cameroon": { lat: 6.29, lng: 12.95, region: "Africa" },
  "Canada": { lat: 57.55, lng: -98.42, region: "North America" },
  "Canarias": { lat: 28.3, lng: -16.54, region: "Europe" },
  "Cayman Islands": { lat: 19.31, lng: -81.25, region: "South America" },
  "Central African Republic": { lat: 6.33, lng: 20.52, region: "Africa" },
  "Chad": { lat: 15.28, lng: 18.43, region: "Africa" },
  "Chile": { lat: -37.83, lng: -70.77, region: "South America" },
  "China": { lat: 38.07, lng: 104.69, region: "Asia" },
  "Christmas Island": { lat: -10.45, lng: 105.7, region: "Oceania" },
  "Cocos Islands": { lat: -12.17, lng: 96.84, region: "Oceania" },
  "Colombia": { lat: 4.19, lng: -72.64, region: "South America" },
  "Comoros": { lat: -11.66, lng: 43.35, region: "Africa" },
  "Congo": { lat: -0.73, lng: 14.88, region: "Africa" },
  "Congo DRC": { lat: -3.34, lng: 23.42, region: "Africa" },
  "Cook Islands": { lat: -21.22, lng: -159.79, region: "Oceania" },
  "Costa Rica": { lat: 9.86, lng: -84.15, region: "South America" },
  "Croatia": { lat: 44.91, lng: 16.63, region: "Europe" },
  "Cuba": { lat: 21.48, lng: -79.7, region: "South America" },
  "Curacao": { lat: 12.2, lng: -68.97, region: "South America" },
  "Cyprus": { lat: 35.12, lng: 33.38, region: "Middle East" },
  "Czech Republic": { lat: 49.75, lng: 15.38, region: "Europe" },
  "Côte d'Ivoire": { lat: 7.54, lng: -5.57, region: "Africa" },
  "Denmark": { lat: 56.0, lng: 9.38, region: "Europe" },
  "Djibouti": { lat: 11.75, lng: 42.61, region: "Africa" },
  "Dominica": { lat: 15.43, lng: -61.36, region: "South America" },
  "Dominican Republic": { lat: 18.78, lng: -70.43, region: "South America" },
  "Ecuador": { lat: -1.56, lng: -78.46, region: "South America" },
  "Egypt": { lat: 26.61, lng: 30.24, region: "Africa" },
  "El Salvador": { lat: 13.76, lng: -88.86, region: "South America" },
  "Equatorial Guinea": { lat: 1.6, lng: 10.43, region: "Africa" },
  "Eritrea": { lat: 15.01, lng: 39.27, region: "Africa" },
  "Estonia": { lat: 58.65, lng: 25.92, region: "Europe" },
  "Eswatini": { lat: -26.56, lng: 31.51, region: "Africa" },
  "Ethiopia": { lat: 8.73, lng: 39.91, region: "Africa" },
  "Falkland Islands": { lat: -51.76, lng: -58.75, region: "South America" },
  "Faroe Islands": { lat: 62.13, lng: -6.98, region: "Europe" },
  "Fiji": { lat: -17.82, lng: 177.98, region: "Oceania" },
  "Finland": { lat: 65.02, lng: 25.66, region: "Europe" },
  "France": { lat: 46.64, lng: 2.19, region: "Europe" },
  "French Guiana": { lat: 3.86, lng: -53.32, region: "South America" },
  "French Polynesia": { lat: -17.67, lng: -149.4, region: "Oceania" },
  "French Southern Territories": { lat: -49.26, lng: 69.55, region: "Africa" },
  "Gabon": { lat: -0.63, lng: 11.84, region: "Africa" },
  "Gambia": { lat: 13.43, lng: -15.38, region: "Africa" },
  "Georgia": { lat: 42.18, lng: 43.38, region: "Middle East" },
  "Germany": { lat: 51.08, lng: 10.43, region: "Europe" },
  "Ghana": { lat: 7.95, lng: -1.22, region: "Africa" },
  "Gibraltar": { lat: 36.14, lng: -5.35, region: "Europe" },
  "Glorioso Islands": { lat: -11.57, lng: 47.29, region: "Africa" },
  "Greece": { lat: 39.42, lng: 23.11, region: "Europe" },
  "Greenland": { lat: 74.17, lng: -42.08, region: "North America" },
  "Grenada": { lat: 12.11, lng: -61.68, region: "South America" },
  "Guadeloupe": { lat: 16.24, lng: -61.54, region: "South America" },
  "Guam": { lat: 13.45, lng: 144.78, region: "Oceania" },
  "Guatemala": { lat: 15.82, lng: -90.31, region: "South America" },
  "Guernsey": { lat: 49.46, lng: -2.58, region: "Europe" },
  "Guinea": { lat: 10.26, lng: -10.99, region: "Africa" },
  "Guinea-Bissau": { lat: 11.98, lng: -14.98, region: "Africa" },
  "Guyana": { lat: 4.68, lng: -58.91, region: "South America" },
  "Haiti": { lat: 18.88, lng: -72.89, region: "South America" },
  "Heard Island and McDonald Islands": { lat: -53.08, lng: 73.49, region: "Oceania" },
  "Honduras": { lat: 14.74, lng: -86.49, region: "South America" },
  "Hungary": { lat: 47.23, lng: 19.4, region: "Europe" },
  "Iceland": { lat: 65.12, lng: -19.06, region: "Europe" },
  "India": { lat: 23.59, lng: 81.17, region: "Asia" },
  "Indonesia": { lat: 0.16, lng: 113.97, region: "Asia" },
  "Iran": { lat: 32.91, lng: 54.24, region: "Asia" },
  "Iraq": { lat: 33.11, lng: 43.83, region: "Middle East" },
  "Ireland": { lat: 53.3, lng: -8.24, region: "Europe" },
  "Isle of Man": { lat: 54.23, lng: -4.53, region: "Europe" },
  "Israel": { lat: 31.51, lng: 35.03, region: "Middle East" },
  "Italy": { lat: 42.98, lng: 12.76, region: "Europe" },
  "Jamaica": { lat: 18.12, lng: -77.3, region: "South America" },
  "Japan": { lat: 36.77, lng: 137.47, region: "Asia" },
  "Jersey": { lat: 49.22, lng: -2.13, region: "Europe" },
  "Jordan": { lat: 31.39, lng: 36.96, region: "Middle East" },
  "Juan De Nova Island": { lat: -17.06, lng: 42.74, region: "Africa" },
  "Kazakhstan": { lat: 47.64, lng: 66.38, region: "Asia" },
  "Kenya": { lat: 0.69, lng: 37.95, region: "Africa" },
  "Kiribati": { lat: 1.87, lng: -157.39, region: "Oceania" },
  "Kuwait": { lat: 29.28, lng: 47.56, region: "Middle East" },
  "Kyrgyzstan": { lat: 41.36, lng: 74.18, region: "Asia" },
  "Laos": { lat: 18.12, lng: 103.76, region: "Asia" },
  "Latvia": { lat: 56.81, lng: 24.69, region: "Europe" },
  "Lebanon": { lat: 33.91, lng: 35.9, region: "Middle East" },
  "Lesotho": { lat: -29.6, lng: 28.24, region: "Africa" },
  "Liberia": { lat: 6.52, lng: -9.26, region: "Africa" },
  "Libya": { lat: 27.2, lng: 17.91, region: "Africa" },
  "Liechtenstein": { lat: 47.15, lng: 9.55, region: "Europe" },
  "Lithuania": { lat: 55.29, lng: 23.95, region: "Europe" },
  "Luxembourg": { lat: 49.78, lng: 6.1, region: "Europe" },
  "Madagascar": { lat: -19.04, lng: 46.68, region: "Africa" },
  "Malawi": { lat: -13.13, lng: 34.23, region: "Africa" },
  "Malaysia": { lat: 3.67, lng: 114.63, region: "Asia" },
  "Maldives": { lat: -0.61, lng: 73.1, region: "Asia" },
  "Mali": { lat: 17.17, lng: -4.35, region: "Africa" },
  "Malta": { lat: 35.89, lng: 14.44, region: "Europe" },
  "Marshall Islands": { lat: 7.31, lng: 168.72, region: "Oceania" },
  "Martinique": { lat: 14.64, lng: -61.01, region: "South America" },
  "Mauritania": { lat: 20.47, lng: -10.5, region: "Africa" },
  "Mauritius": { lat: -20.28, lng: 57.56, region: "Africa" },
  "Mayotte": { lat: -12.82, lng: 45.13, region: "Africa" },
  "Mexico": { lat: 23.87, lng: -101.55, region: "South America" },
  "Micronesia": { lat: 6.88, lng: 158.23, region: "Oceania" },
  "Moldova": { lat: 47.07, lng: 28.39, region: "Europe" },
  "Monaco": { lat: 43.75, lng: 7.41, region: "Europe" },
  "Mongolia": { lat: 47.09, lng: 103.4, region: "Asia" },
  "Montenegro": { lat: 42.74, lng: 19.3, region: "Europe" },
  "Montserrat": { lat: 16.74, lng: -62.19, region: "South America" },
  "Morocco": { lat: 28.69, lng: -8.82, region: "Africa" },
  "Mozambique": { lat: -17.53, lng: 35.21, region: "Africa" },
  "Myanmar": { lat: 19.9, lng: 97.09, region: "Asia" },
  "Namibia": { lat: -21.91, lng: 18.16, region: "Africa" },
  "Nauru": { lat: -0.52, lng: 166.93, region: "Oceania" },
  "Nepal": { lat: 28.3, lng: 84.13, region: "Asia" },
  "Netherlands": { lat: 52.13, lng: 5.55, region: "Europe" },
  "New Caledonia": { lat: -21.33, lng: 165.51, region: "Oceania" },
  "New Zealand": { lat: -43.83, lng: 170.69, region: "Oceania" },
  "Nicaragua": { lat: 12.89, lng: -85.02, region: "South America" },
  "Niger": { lat: 17.08, lng: 8.87, region: "Africa" },
  "Nigeria": { lat: 9.61, lng: 8.15, region: "Africa" },
  "Niue": { lat: -19.05, lng: -169.87, region: "Oceania" },
  "Norfolk Island": { lat: -29.04, lng: 167.95, region: "Oceania" },
  "North Korea": { lat: 40.19, lng: 127.34, region: "Asia" },
  "North Macedonia": { lat: 41.59, lng: 21.71, region: "Europe" },
  "Northern Mariana Islands": { lat: 15.18, lng: 145.74, region: "Oceania" },
  "Norway": { lat: 64.98, lng: 16.67, region: "Europe" },
  "Oman": { lat: 20.72, lng: 55.84, region: "Middle East" },
  "Pakistan": { lat: 30.12, lng: 69.09, region: "Asia" },
  "Palau": { lat: 7.53, lng: 134.58, region: "Oceania" },
  "Palestinian Territory": { lat: 31.93, lng: 35.24, region: "Middle East" },
  "Panama": { lat: 8.44, lng: -80.14, region: "South America" },
  "Papua New Guinea": { lat: -7.16, lng: 144.83, region: "Oceania" },
  "Paraguay": { lat: -23.42, lng: -58.39, region: "South America" },
  "Peru": { lat: -8.52, lng: -74.11, region: "South America" },
  "Philippines": { lat: 15.59, lng: 121.82, region: "Asia" },
  "Pitcairn": { lat: -24.37, lng: -128.31, region: "Oceania" },
  "Poland": { lat: 52.07, lng: 19.44, region: "Europe" },
  "Portugal": { lat: 39.68, lng: -7.93, region: "Europe" },
  "Puerto Rico": { lat: 18.22, lng: -66.49, region: "South America" },
  "Qatar": { lat: 25.32, lng: 51.2, region: "Middle East" },
  "Romania": { lat: 45.82, lng: 25.09, region: "Europe" },
  "Russian Federation": { lat: 59.04, lng: 98.67, region: "Europe" },
  "Rwanda": { lat: -2.01, lng: 29.92, region: "Africa" },
  "Réunion": { lat: -21.12, lng: 55.54, region: "Africa" },
  "Saba": { lat: 17.63, lng: -63.24, region: "South America" },
  "Saint Barthelemy": { lat: 17.91, lng: -62.83, region: "South America" },
  "Saint Eustatius": { lat: 17.49, lng: -62.98, region: "South America" },
  "Saint Helena": { lat: -15.96, lng: -5.72, region: "Africa" },
  "Saint Kitts and Nevis": { lat: 17.31, lng: -62.75, region: "South America" },
  "Saint Lucia": { lat: 13.9, lng: -60.97, region: "South America" },
  "Saint Martin": { lat: 18.08, lng: -63.07, region: "South America" },
  "Saint Pierre and Miquelon": { lat: 46.95, lng: -56.32, region: "North America" },
  "Saint Vincent and the Grenadines": { lat: 13.25, lng: -61.19, region: "South America" },
  "Samoa": { lat: -13.63, lng: -172.44, region: "Oceania" },
  "San Marino": { lat: 43.94, lng: 12.46, region: "Europe" },
  "Sao Tome and Principe": { lat: 0.23, lng: 6.61, region: "Africa" },
  "Saudi Arabia": { lat: 24.14, lng: 44.6, region: "Middle East" },
  "Senegal": { lat: 14.23, lng: -14.61, region: "Africa" },
  "Serbia": { lat: 44.03, lng: 20.86, region: "Europe" },
  "Seychelles": { lat: -4.66, lng: 55.47, region: "Africa" },
  "Sierra Leone": { lat: 8.56, lng: -11.79, region: "Africa" },
  "Singapore": { lat: 1.35, lng: 103.81, region: "Asia" },
  "Sint Maarten": { lat: 18.04, lng: -63.07, region: "South America" },
  "Slovakia": { lat: 48.7, lng: 19.58, region: "Europe" },
  "Slovenia": { lat: 46.14, lng: 14.89, region: "Europe" },
  "Solomon Islands": { lat: -9.61, lng: 160.16, region: "Oceania" },
  "Somalia": { lat: 6.52, lng: 45.4, region: "Africa" },
  "South Africa": { lat: -28.55, lng: 24.75, region: "Africa" },
  "South Georgia and South Sandwich Islands": { lat: -54.38, lng: -36.78, region: "South America" },
  "South Korea": { lat: 36.4, lng: 127.76, region: "Asia" },
  "South Sudan": { lat: 7.66, lng: 30.39, region: "Africa" },
  "Spain": { lat: 40.37, lng: -3.65, region: "Europe" },
  "Sri Lanka": { lat: 7.7, lng: 80.67, region: "Asia" },
  "Sudan": { lat: 15.67, lng: 29.95, region: "Africa" },
  "Suriname": { lat: 4.1, lng: -55.86, region: "South America" },
  "Svalbard": { lat: 78.57, lng: 16.04, region: "Europe" },
  "Sweden": { lat: 62.73, lng: 17.06, region: "Europe" },
  "Switzerland": { lat: 46.74, lng: 8.29, region: "Europe" },
  "Syria": { lat: 35.1, lng: 38.51, region: "Middle East" },
  "Tajikistan": { lat: 38.57, lng: 70.94, region: "Asia" },
  "Tanzania": { lat: -6.36, lng: 34.82, region: "Africa" },
  "Thailand": { lat: 13.66, lng: 101.09, region: "Asia" },
  "Timor-Leste": { lat: -8.81, lng: 125.95, region: "Asia" },
  "Togo": { lat: 8.66, lng: 0.9, region: "Africa" },
  "Tokelau": { lat: -9.2, lng: -171.85, region: "Oceania" },
  "Tonga": { lat: -21.16, lng: -175.2, region: "Oceania" },
  "Trinidad and Tobago": { lat: 10.42, lng: -61.37, region: "South America" },
  "Tunisia": { lat: 34.09, lng: 9.66, region: "Africa" },
  "Turkey": { lat: 38.93, lng: 35.57, region: "Middle East" },
  "Turkmenistan": { lat: 39.06, lng: 58.46, region: "Asia" },
  "Turks and Caicos Islands": { lat: 21.8, lng: -71.74, region: "South America" },
  "Tuvalu": { lat: -8.51, lng: 179.22, region: "Oceania" },
  "US Virgin Islands": { lat: 17.74, lng: -64.76, region: "South America" },
  "Uganda": { lat: 1.28, lng: 32.34, region: "Africa" },
  "Ukraine": { lat: 48.66, lng: 31.27, region: "Europe" },
  "United Arab Emirates": { lat: 24.18, lng: 54.28, region: "Middle East" },
  "United Kingdom": { lat: 53.98, lng: -2.85, region: "Europe" },
  "United States": { lat: 38.82, lng: -96.33, region: "North America" },
  "United States Minor Outlying Islands": { lat: 19.3, lng: 166.64, region: "Oceania" },
  "Uruguay": { lat: -32.78, lng: -56.02, region: "South America" },
  "Uzbekistan": { lat: 41.49, lng: 63.85, region: "Asia" },
  "Vanuatu": { lat: -15.19, lng: 166.85, region: "Oceania" },
  "Vatican City": { lat: 41.9, lng: 12.45, region: "Europe" },
  "Venezuela": { lat: 7.15, lng: -66.36, region: "South America" },
  "Vietnam": { lat: 16.52, lng: 105.91, region: "Asia" },
  "Wallis and Futuna": { lat: -14.28, lng: -178.13, region: "Oceania" },
  "Yemen": { lat: 16.0, lng: 47.47, region: "Middle East" },
  "Zambia": { lat: -13.16, lng: 27.76, region: "Africa" },
  "Zimbabwe": { lat: -18.93, lng: 29.72, region: "Africa" },
  "Russia": { lat: 59.04, lng: 98.67, region: "Europe" },
  "Brunei": { lat: 4.54, lng: 114.64, region: "Asia" },
  "Ivory Coast": { lat: 7.54, lng: -5.57, region: "Africa" },
  "Swaziland": { lat: -26.56, lng: 31.51, region: "Africa" },
  "Cape Verde": { lat: 15.08, lng: -23.63, region: "Africa" },
  "East Timor": { lat: -8.81, lng: 125.95, region: "Asia" },
  "UAE": { lat: 24.18, lng: 54.28, region: "Middle East" },
};

function normalizeCountryToken(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[.']/g, '')
    .replace(/\s+/g, ' ');
}

const COUNTRY_GEO_BY_NORMALIZED_NAME: Record<string, string> = Object.keys(COUNTRY_GEO).reduce(
  (acc, key) => {
    acc[normalizeCountryToken(key)] = key;
    return acc;
  },
  {} as Record<string, string>,
);

/**
 * ISO 3166-1 alpha-2 codes and other common short-form aliases for the countries in
 * COUNTRY_GEO — merchant/acquirer records often store "US"/"UK" instead of the full country
 * name, so these resolve to the canonical COUNTRY_GEO key. Keys are lowercase.
 */
const COUNTRY_ALIASES: Record<string, string> = {
  af: 'Afghanistan', al: 'Albania', dz: 'Algeria', as: 'American Samoa', ad: 'Andorra',
  ao: 'Angola', ai: 'Anguilla', ag: 'Antigua and Barbuda', ar: 'Argentina', am: 'Armenia',
  aw: 'Aruba', au: 'Australia', at: 'Austria', az: 'Azerbaijan', bs: 'Bahamas',
  bh: 'Bahrain', bd: 'Bangladesh', bb: 'Barbados', by: 'Belarus', be: 'Belgium',
  bz: 'Belize', bj: 'Benin', bm: 'Bermuda', bt: 'Bhutan', bo: 'Bolivia',
  bq: 'Bonaire', ba: 'Bosnia and Herzegovina', bw: 'Botswana', bv: 'Bouvet Island', br: 'Brazil',
  io: 'British Indian Ocean Territory', vg: 'British Virgin Islands', bn: 'Brunei Darussalam',
  bg: 'Bulgaria', bf: 'Burkina Faso', bi: 'Burundi', cv: 'Cabo Verde', kh: 'Cambodia',
  cm: 'Cameroon', ca: 'Canada', ky: 'Cayman Islands', cf: 'Central African Republic', td: 'Chad',
  cl: 'Chile', cn: 'China', cx: 'Christmas Island', cc: 'Cocos Islands', co: 'Colombia',
  km: 'Comoros', cg: 'Congo', cd: 'Congo DRC', ck: 'Cook Islands', cr: 'Costa Rica',
  hr: 'Croatia', cu: 'Cuba', cw: 'Curacao', cy: 'Cyprus', cz: 'Czech Republic',
  czechia: 'Czech Republic', ci: "Côte d'Ivoire", 'ivory coast': "Côte d'Ivoire",
  dk: 'Denmark', dj: 'Djibouti', dm: 'Dominica', do: 'Dominican Republic', ec: 'Ecuador',
  eg: 'Egypt', sv: 'El Salvador', gq: 'Equatorial Guinea', er: 'Eritrea', ee: 'Estonia',
  sz: 'Eswatini', swaziland: 'Eswatini', et: 'Ethiopia', fk: 'Falkland Islands', fo: 'Faroe Islands',
  fj: 'Fiji', fi: 'Finland', fr: 'France', gf: 'French Guiana', pf: 'French Polynesia',
  tf: 'French Southern Territories', ga: 'Gabon', gm: 'Gambia', ge: 'Georgia', de: 'Germany',
  gh: 'Ghana', gi: 'Gibraltar', gr: 'Greece', gl: 'Greenland', gd: 'Grenada',
  gp: 'Guadeloupe', gu: 'Guam', gt: 'Guatemala', gg: 'Guernsey', gn: 'Guinea',
  gw: 'Guinea-Bissau', gy: 'Guyana', ht: 'Haiti', hm: 'Heard Island and McDonald Islands', hn: 'Honduras',
  hu: 'Hungary', is: 'Iceland', in: 'India', id: 'Indonesia', ir: 'Iran',
  iq: 'Iraq', ie: 'Ireland', im: 'Isle of Man', il: 'Israel', it: 'Italy',
  jm: 'Jamaica', jp: 'Japan', je: 'Jersey', jo: 'Jordan', kz: 'Kazakhstan',
  ke: 'Kenya', ki: 'Kiribati', kw: 'Kuwait', kg: 'Kyrgyzstan', la: 'Laos',
  lv: 'Latvia', lb: 'Lebanon', ls: 'Lesotho', lr: 'Liberia', ly: 'Libya',
  li: 'Liechtenstein', lt: 'Lithuania', lu: 'Luxembourg', mg: 'Madagascar', mw: 'Malawi',
  my: 'Malaysia', mv: 'Maldives', ml: 'Mali', mt: 'Malta', mh: 'Marshall Islands',
  mq: 'Martinique', mr: 'Mauritania', mu: 'Mauritius', yt: 'Mayotte', mx: 'Mexico',
  fm: 'Micronesia', md: 'Moldova', mc: 'Monaco', mn: 'Mongolia', me: 'Montenegro',
  ms: 'Montserrat', ma: 'Morocco', mz: 'Mozambique', mm: 'Myanmar', burma: 'Myanmar',
  na: 'Namibia', nr: 'Nauru', np: 'Nepal', nl: 'Netherlands', holland: 'Netherlands',
  nc: 'New Caledonia', nz: 'New Zealand', ni: 'Nicaragua', ne: 'Niger', ng: 'Nigeria',
  nu: 'Niue', nf: 'Norfolk Island', kp: 'North Korea', mk: 'North Macedonia', macedonia: 'North Macedonia',
  mp: 'Northern Mariana Islands', no: 'Norway', om: 'Oman', pk: 'Pakistan', pw: 'Palau',
  ps: 'Palestinian Territory', pa: 'Panama', pg: 'Papua New Guinea', py: 'Paraguay', pe: 'Peru',
  ph: 'Philippines', pn: 'Pitcairn', pl: 'Poland', pt: 'Portugal', pr: 'Puerto Rico',
  qa: 'Qatar', ro: 'Romania', ru: 'Russian Federation', russia: 'Russian Federation',
  rw: 'Rwanda', re: 'Réunion', bl: 'Saint Barthelemy', sh: 'Saint Helena', kn: 'Saint Kitts and Nevis',
  lc: 'Saint Lucia', mf: 'Saint Martin', pm: 'Saint Pierre and Miquelon', vc: 'Saint Vincent and the Grenadines',
  ws: 'Samoa', sm: 'San Marino', st: 'Sao Tome and Principe', sa: 'Saudi Arabia', sn: 'Senegal',
  rs: 'Serbia', sc: 'Seychelles', sl: 'Sierra Leone', sg: 'Singapore', sx: 'Sint Maarten',
  sk: 'Slovakia', si: 'Slovenia', sb: 'Solomon Islands', so: 'Somalia', za: 'South Africa',
  gs: 'South Georgia and South Sandwich Islands', kr: 'South Korea', ss: 'South Sudan', es: 'Spain',
  lk: 'Sri Lanka', sd: 'Sudan', sr: 'Suriname', sj: 'Svalbard', se: 'Sweden',
  ch: 'Switzerland', sy: 'Syria', tj: 'Tajikistan', tz: 'Tanzania', th: 'Thailand',
  tl: 'Timor-Leste', 'east timor': 'Timor-Leste', tg: 'Togo', tk: 'Tokelau', to: 'Tonga',
  tt: 'Trinidad and Tobago', tn: 'Tunisia', tr: 'Turkey', tm: 'Turkmenistan', tc: 'Turks and Caicos Islands',
  tv: 'Tuvalu', vi: 'US Virgin Islands', ug: 'Uganda', ua: 'Ukraine', ae: 'United Arab Emirates',
  uae: 'United Arab Emirates', gb: 'United Kingdom', uk: 'United Kingdom', 'great britain': 'United Kingdom',
  us: 'United States', usa: 'United States', 'united states of america': 'United States',
  um: 'United States Minor Outlying Islands', uy: 'Uruguay', uz: 'Uzbekistan', vu: 'Vanuatu',
  va: 'Vatican City', vatican: 'Vatican City', ve: 'Venezuela', vn: 'Vietnam',
  wf: 'Wallis and Futuna', ye: 'Yemen', zm: 'Zambia', zw: 'Zimbabwe',
};

/**
 * Resolves a raw country string from merchant/acquirer records (which may be a full name,
 * an ISO2 code like "US"/"UK", or slightly differently-cased/punctuated) to its lat/lng/region
 * entry in COUNTRY_GEO. Returns undefined only when the country genuinely can't be matched.
 */
export function resolveCountryGeo(
  rawCountry: string | null | undefined,
): { lat: number; lng: number; region: string } | undefined {
  if (!rawCountry) return undefined;
  const trimmed = rawCountry.trim();
  if (!trimmed || trimmed === '—' || trimmed === '-') return undefined;

  if (COUNTRY_GEO[trimmed]) return COUNTRY_GEO[trimmed];

  const normalized = normalizeCountryToken(trimmed);
  const canonicalKey = COUNTRY_GEO_BY_NORMALIZED_NAME[normalized] || COUNTRY_ALIASES[normalized];
  return canonicalKey ? COUNTRY_GEO[canonicalKey] : undefined;
}

export const REGION_FLAGS: Record<string, string> = {
  Europe: "🇪🇺",
  "Middle East": "🇦🇪",
  Asia: "🇸🇬",
  "North America": "🇺🇸",
  Africa: "🇿🇦",
  "South America": "🇧🇷",
  Oceania: "🇦🇺",
};

export const ACCENT_COLORS = [
  '#5c6bc0', '#26a69a', '#ffa502', '#ff6b6b', '#a78bfa', '#2ed573',
];

export const SEARCH_DEBOUNCE_MS = 400;

export const ACQUIRER_PARTNER_TYPE = 'Acquiring partner';

export const EMPTY_ACQUIRER_COLUMN_FILTERS: AcquirerColumnFilters = {
  name: null,
  industryType: null,
  code: null,
  country: null,
  paymentMethods: null,
  status: null,
  trafficTypes: null,
  currencies: null,
  totalTerminals: null,
  terminalNames: null,
  createdAt: null,
};

export const MODAL_TITLE_TO_FILTER_KEY: Record<string, AcquirerColumnFilterKey> = {
  'Payment Methods': 'paymentMethods',
  'Traffic Types': 'trafficTypes',
  'Supported Currencies': 'currencies',
  'Terminal Names': 'terminalNames',
};
